<template>
    <div>
        <div>
            <div>
                <el-form :model="reportForm"  :rules="rulesReport" ref="reportForm" label-width="150px" size="small">
                    <el-form-item :label="$t('m.m_accounting')+'：'"  v-if="canType1">
                        <template v-for="(item,index) in dataTypeArrar" v-if="item.view&&item.type==1">
                            <el-radio-group v-model="reportForm.dataType">
                                <el-radio :label="item.value"  style="width: 150px;">{{item.label}}</el-radio>
                            </el-radio-group>
                        </template>
                    </el-form-item>
                    <el-form-item :label="$t('m.t_customer')+'：'" prop="custId" v-if="this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==5||this.reportForm.dataType==6">
                        <el-select v-model="reportForm.custId" default-first-option  placeholder="" filterable remote  :remote-method="itemRemoteMethod" clearable @clear="reportForm.custId = ''"  style="width:250px">
                            <el-option
                                    v-for="item in custOptions"
                                    :key="item.id"
                                    :label="item.code"
                                    :value="item.id">
                                <span style="float: left">{{ item.code }}</span>&nbsp;
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('m.t_date')+'：'" v-if="this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6">
                        <el-select v-model="reportForm.type" filterable remote :placeholder="this.$t('m.t_date')" style="width:250px">
                            <el-option
                                    v-for="item in statusOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('m.t_monthDate')+'：'" prop="monthDate" v-if="(this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6) && this.reportForm.type==0">
                        <el-date-picker
                                v-model="reportForm.monthDate"
                                value-format="yyyy-MM"
                                type="month"
                                placeholder=""
                                style="width:250px;margin-top: -8px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('m.t_quarterDate')+'：'" prop="salesDate" v-if="(this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6)&& this.reportForm.type==1">
                        <el-date-picker
                                v-model="reportForm.salesDate"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="~"
                                :start-placeholder="$t('m.t_startdate')"
                                :end-placeholder="$t('m.t_enddate')"
                                :picker-options="pickerOptions2" style="width:250px">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('m.t_yearDate')+'：'" prop="yearDate" v-if="(this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6) && this.reportForm.type==2">
                        <el-date-picker
                                v-model="reportForm.yearDate"
                                value-format="yyyy"
                                type="year"
                                placeholder=""
                                style="width:250px;margin-top: -8px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('m.menu_jobNo')+'：'"  v-if="this.reportForm.dataType==5">
                        <el-input v-model="reportForm.jobNo"  placeholder="" style="width:250px" />
                    </el-form-item>
                    <el-form-item :label="$t('m.t_ExportFormat')+'：'" v-if="this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==5||this.reportForm.dataType==6">
                        <el-select v-model="reportForm.exportFormat" filterable remote :placeholder="this.$t('m.t_ExportFormat')" style="width:250px">
                            <el-option
                                    v-for="item in formatOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="this.reportForm.dataType>0">
                        <el-button type="primary" @click="submitForm('reportForm')" :disabled="loadingStatus">{{$t('m.t_export')}}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getGroupByCatCode,getCustAllCustMgtList} from '../api/api'
    import { Loading } from 'element-ui'

    export default {
        data() {
            return {
                pickerOptions3: {
                    shortcuts: [{
                        text: this.$t("m.t_lastweek"),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t("m.t_lastmonth"),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t("m.t_lastthreemonth"),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                pickerOptions2: {
                    shortcuts: [{
                        text: this.$t('m.t_lastweek'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t('m.t_lastmonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t('m.t_lastthreemonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                staffOptions:[],
                dataTypeArrar:[],
                groupOption:[],
                custOptions:[],
                disabled:false,
                reportForm: {
                    monthDate:'',
                    salesDate:'',
                    yearDate:'',
                    type:0,
                    custId:'',
                    exportFormat:0,
                    jobNo: ''
                },
                itemStatusOption:[],
                rulesReport: {
                    salesDate: [
                        {required: true, message: this.$t('m.m_date'), trigger: 'change' }
                    ],
                    monthDate: [
                        {required: true, message: this.$t('m.m_monthDate'), trigger: 'change' }
                    ],
                    yearDate: [
                        {required: true, message: this.$t('m.m_yearDate'), trigger: 'change' }
                    ]
                   /* custNo: [
                        {required: true, message: this.$t('m.m_customer'), trigger: 'change' }
                    ],*/
                },
                statusOptions:[{
                    value:0,
                    label:this.$t('m.t_monthDate')
                },{
                    value:1,
                    label:this.$t('m.t_quarterDate')
                },{
                    value:2,
                    label:this.$t('m.t_yearDate')
                }
                ],
                formatOptions:[{
                    value:0,
                    label:'xlsx'
                },{
                    value:1,
                    label:'xls'
                },{
                    value:2,
                    label:'csv'
                }
                ],
            };
        },
        watch:{
            valDataType(val, oldVal){
                this.reportForm.monthDate="";
                this.reportForm.salesDate="";
                this.reportForm.type=0;
                this.reportForm.yearDate="";
                this.reportForm.custId="";
                this.reportForm.jobNo="";
                this.loadingStatus=false;
            }
        },
        methods: {
            downloadFile(url, name, callback) {
                let this_ = this
                const loading = Loading.service({
                    fullscreen: true,
                    text: ''
                })
                fetch(url)
                    .then(response => response.blob())
                    .then(blob => {
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        const suffix = this_.reportForm.exportFormat === 0 ? '.xlsx' : this_.reportForm.exportFormat === 1 ? '.xls' : '.csv'
                        link.download = name + suffix // 设置下载的文件名
                        link.click()
                        URL.revokeObjectURL(link.href)
                        callback(null, 'Download complete')
                        loading.close()
                    })
                    .catch(error => {
                        callback(error, null)
                        loading.close()
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let dataType=this.reportForm.dataType;
                        switch (dataType) {
                            case 1: case 2: case 3:case 4:case 6:
                                let name = dataType === 1 ? 'task-list_' : dataType === 2 ? 'cust-list_' : dataType === 3 ? 'stockin-list_' : dataType === 4 ? 'stockout-list_' : 'stockinout-list_'
                                if(this.reportForm.type==0){
                                    if(this.reportForm.monthDate!=null&&this.reportForm.monthDate!="") {
                                        const str = this.reportForm.monthDate.replace('-','').substring(2)
                                        name += str
                                        let startTime = Math.round(new Date(this.reportForm.monthDate).getTime() / 1000);
                                        // window.location.href = axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + startTime +"&type=" + this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                                        this.downloadFile(axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + startTime +"&type=" + this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token, name, (error, message) => {
                                            if (error) {
                                                console.error('Download failed:', error);
                                            } else {
                                                console.log(message);
                                            }
                                        });
                                    }
                                }else if(this.reportForm.type==1){
                                    if(this.reportForm.salesDate!=null&&this.reportForm.salesDate!="") {
                                        const str = this.reportForm.salesDate[0].replaceAll('-','').substring(2) + '_' + this.reportForm.salesDate[1].replaceAll('-','').substring(2)
                                        name += str
                                        let startTime = Math.round(new Date(this.reportForm.salesDate[0]).getTime() / 1000);
                                        let endTime = Math.round(new Date(this.reportForm.salesDate[1]).getTime() / 1000);
                                        // window.location.href=axios.defaults.baseURL+'/viewReport/report/?dataType='+dataType+'&startTime='+startTime+"&endTime="+endTime+'&type='+this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                                        this.downloadFile(axios.defaults.baseURL+'/viewReport/report/?dataType='+dataType+'&startTime='+startTime+"&endTime="+endTime+'&type='+this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token, name, (error, message) => {
                                            if (error) {
                                                console.error('Download failed:', error);
                                            } else {
                                                console.log(message);
                                            }
                                        });
                                    }
                                }else{
                                    if(this.reportForm.yearDate!=null&&this.reportForm.yearDate!="") {
                                        const str = this.reportForm.yearDate.substring(2)
                                        name += str
                                        let startTime = Math.round(new Date(this.reportForm.yearDate).getTime() / 1000);
                                        // window.location.href = axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + startTime + "&type=" + this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                                        this.downloadFile(axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + startTime + "&type=" + this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token, name, (error, message) => {
                                            if (error) {
                                                console.error('Download failed:', error);
                                            } else {
                                                console.log(message);
                                            }
                                        });
                                    }
                                }
                                break;
                            case 5:
                                // window.location.href = axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType+ "&type=5" +"&jobNo=" + this.reportForm.jobNo+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                                this.downloadFile(axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType+ "&type=5" +"&jobNo=" + this.reportForm.jobNo+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token, 'existing-list', (error, message) => {
                                    if (error) {
                                        console.error('Download failed:', error);
                                    } else {
                                        console.log(message);
                                    }
                                });
                                break;
                           /* case 2:
                                window.location.href=axios.defaults.baseURL+'/viewReport/report/?dataType='+dataType+'&startTime='+startTime+"&endTime="+endTime+'&type='+this.reportForm.type+'&custId='+this.reportForm.custId;
                                break;*/
                        }
                    }
                });
            },
            itemRemoteMethod(query){
                if (query!=""){
                    var params={custNo:query,groupId:null};
                    getCustAllCustMgtList(params).then(data=>{
                        let {data:res={}}=data;
                        this.custOptions=res.data;
                    });
                }
            },
           /* getItsGroupByCatCode(){
                return getGroupByCatCode("ITS").then(res=>{
                    if(res.errcode==200){
                        let {data:status=[]}=res;
                        for(let i=0;i<status.length;i++){
                            this.itemStatusOption.push(status[i]);
                        }
                    }else{
                        this.$message.error(data.errmsg);
                    }
                }).catch((error)=>{
                    console.log("getUnGroupByCatCode Error");
                })

            },*/
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }

        },
        mounted() {
           /* this.getItsGroupByCatCode();
            getStaffAll().then(data=>{
                this.staffOptions=data.data;
            });
            getCustGroupAll().then(data=>{
                this.groupOption=data.data==null?[]:data.data;
            });*/
        },
        computed: {
            canTask(){
                return this.$store.getters.hasPermission("TASK_LIST_EXECL");
            },
            canCust(){
                return this.$store.getters.hasPermission("CUST_LIST_EXECL");
            },
            canStorIn(){
                return this.$store.getters.hasPermission("STOR_IN_EXECL");
            },
            canStorOn(){
                return this.$store.getters.hasPermission("STOR_ON_EXECL");
            },
            canExisting(){
                return this.$store.getters.hasPermission("STOR_EXISTING_EXECL");
            },
            valDataType(){
                return this.reportForm.dataType;
            },
            canType1(){
                let val=false;
                for (var i=0;i<this.dataTypeArrar.length;i++){
                    if (this.dataTypeArrar[i].type==1&&this.dataTypeArrar[i].view){
                        val=true;
                    }
                }
                return val;
            },
        },
        activated(){
            this.dataTypeArrar=[{
                value: 1,
                label: this.$t("m.menu_task"),
                type:1,
                view:this.canTask
            },
            {
                value: 2,
                label: this.$t("m.menu_cust"),
                type:1,
                view:this.canCust
            },
            {
                value: 3,
                label: this.$t("m.menu_storIn"),
                type:1,
                view:this.canStorIn
            }, {
                value: 4,
                label: this.$t("m.menu_storOn"),
                type:1,
                view:this.canStorOn
            }, {
                value: 6,
                label: this.$t("m.menu_storInOn"),
                type:1,
                view:this.canStorOn
            },{
                value: 5,
                label: this.$t("m.menu_existing"),
                type:1,
                view:this.canExisting
            }
            ]
        }
    }

</script>

<style lang="scss" scoped>
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }

    #table_vs td{padding:6px; border:1px solid #f2f2f2; background: #fff;}
</style>


// WEBPACK FOOTER //
// src/views/ExcelExport.vue